/* eslint-env browser, es6 */
import m from "mithril";

import { TIME_LIMIT_MS } from "../constants";
import { focusAndScrollInput } from "../utils";

class TimerViewController {
  private intervalId: number | undefined;
  private isPaused: boolean;
  private durationLeftMs: number;
  private durationLeftAtLastPauseMs: number;
  private timeStartedMs: number;

  private hookOnToggle: () => void;
  private hookOnFinish: () => void;

  constructor(hookOnToggle: () => void, hookOnFinish: () => void) {
    this.intervalId = undefined;
    this.isPaused = false;
    this.durationLeftMs = TIME_LIMIT_MS;
    this.durationLeftAtLastPauseMs = TIME_LIMIT_MS;
    this.timeStartedMs = 0;

    this.hookOnToggle = hookOnToggle;
    this.hookOnFinish = hookOnFinish;
  }

  start() {
    this.timeStartedMs = Date.now();
    this.intervalId = setInterval(() => {
      const finished = this.tick();
      if (finished) {
        clearInterval(this.intervalId);
      }
      m.redraw();
    }, 50);
  }

  remove() {
    if (this.intervalId !== undefined) {
      clearInterval(this.intervalId);
    }
  }

  tick() {
    if (this.isPaused) {
      return;
    }

    const timeNowMs = Date.now();
    const durationElapsedMs = timeNowMs - this.timeStartedMs;
    const durationLeftMs = this.durationLeftAtLastPauseMs - durationElapsedMs;
    if (durationLeftMs >= 0) {
      this.durationLeftMs = durationLeftMs;
      return false;
    } else {
      this.hookOnFinish();
      return true;
    }
  }

  toggle() {
    if (this.isPaused) {
      this.isPaused = false;
      this.timeStartedMs = Date.now();
      this.durationLeftAtLastPauseMs = this.durationLeftMs;

      // TODO(2023-06-04): Find a better way to do this than `setTimeout`.
      setTimeout(focusAndScrollInput, 100);
    } else {
      this.isPaused = true;
    }

    this.hookOnToggle();
  }

  getDurationLeftMs(): number {
    return this.durationLeftMs;
  }
}

interface TimerViewAttrs {
  hookOnToggle: () => void;
  hookOnFinish: () => void;
}

export class TimerView implements m.Component<TimerViewAttrs> {
  private controller: TimerViewController;

  constructor(vnode: m.Vnode<TimerViewAttrs>) {
    this.controller = new TimerViewController(
      vnode.attrs.hookOnToggle,
      vnode.attrs.hookOnFinish
    );
  }

  oncreate() {
    this.controller.start();
  }

  onremove() {
    this.controller.remove();
  }

  view(): m.Children {
    const secondsLeft = Math.floor(this.controller.getDurationLeftMs() / 1000);
    const minutes = Math.floor(secondsLeft / 60);
    const seconds = secondsLeft % 60;
    const paddedSeconds = ("" + seconds).padStart(2, "0");
    return m(
      "button",
      {
        onclick: () => {
          this.controller.toggle();
        },
      },
      `${minutes}:${paddedSeconds}`
    );
  }
}
